var _circle, _text, _circle2, _text2, _circle3, _text3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailsB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 28,
    r: 12,
    fill: "#C75E5A"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 33,
    fontFamily: "sans-serif",
    fontSize: 13,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "1")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 36,
    r: 12,
    fill: "#F9907B"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 41,
    fontFamily: "sans-serif",
    fontSize: 13,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "2")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 72,
    r: 12,
    fill: "#C75E5A"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 77,
    fontFamily: "sans-serif",
    fontSize: 13,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "3")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 28L60 36",
    stroke: "#FAC1B5",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46L46 64",
    stroke: "#FAC1B5",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailsB);
export default __webpack_public_path__ + "static/media/TrailsB.b10c393b7b528b376e02c309cb37f679.svg";
export { ForwardRef as ReactComponent };